module.exports = __webpack_public_path__ + "static/media/business-prec-metals-chart.04c64e45.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/business-prec-metals-chart.png
// module id = 505
// module chunks = 0